export enum GetterNames {
  TOTALWEEKLYDRINKS = "totalWeeklyDrinks",
  AUDITCSCORE = "auditCScore",
  CALORIESANDUNITSFOREACHDAY = "caloriesAndUnitsForEachDay",
  ORIGINALCALORIESANDUNITSFOREACHDAY = "originalCaloriesAndUnitsForEachDay",
  WEEKLYUNITSANDCALORIES = "weeklyUnitsAndCalories",
  ORIGINALWEEKLYUNITSANDCALORIES = "originalWeeklyUnitsAndCalories",
  WEEKLYUNITSASDRINKS = "weeklyUnitsAsDrinks",
  WEEKLYDRINKS = "weeklyDrinks",
  DRINKERTYPE = "drinkerType",
  HIGHESTUNITSPERDAY = "highestUnitsPerDay",
  DAILYUNITSANDCALORIES = "dailyUnitsAndCalories",
  DAILYUNITSCORE = "dailyUnitScore",
  ISDANGEROUSTOHEALTH = "isDangerousToHealth",
  ISBINGEDRINKER = "isBingeDrinker",
  ISLOWRISKBINGEDRINKER = "isLowRiskBingeDrinker",
  RISKLEVEL = "riskLevel",
  RISKLEVELBEFORECHANGES = "riskLevelBeforeChanges",
  AMOUNTABOVELOWRISK = "amountAboveLowRisk",
  WEEKLYCALORIESASBURGERS = "weeklyCaloriesAsBurgers",
  WEEKLYUNITSASSPIRITS = "weeklyUnitsAsSpirits",
  WEEKLYUNITSASBEERS = "weeklyUnitsAsBeers",
  PERCENTWHODRINKLESS = "percentWhoDrinkLess",
  ORIGINALPERCENTWHODRINKLESS = "originalPercentWhoDrinkLess"
}
